import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    [theme.breakpoints.up('md')]: {
      padding: '32px 34px'
    }
  },
  card: {
    marginTop: 48,
    marginBottom: 32,
    '& + &': {
      marginTop: 64,
      [theme.breakpoints.up('md')]: {
        marginTop: 128
      }
    }
  },
  row: {
    marginTop: 16,
    marginBottom: 16
  },
  heading1: {
    marginBottom: 48
  },
  list: {
    marginBottom: 16
  },
  listItem: {
    marginTop: 32,
    [theme.breakpoints.up('sm')]: {
      marginTop: 48
    }
  },
  dt: {
    marginBottom: 8
  },
  divider: {
    height: '1px',
    color: '#C7C7C7',
    margin: '8px 0 0'
  },
  buttonContainer: {
    marginTop: 20,
    paddingBottom: 20,
    marginBottom: 20
  },
  boldText: {
    marginBottom: 8,
    fontWeight: 600,
    ...theme.typography.body_largeRegular,
    [theme.breakpoints.up('sm')]: {
      ...theme.typography.body_extraLargeRegular
    }
  },
  bodyText: {
    ...theme.typography.body_smallRegular,
    [theme.breakpoints.up('sm')]: {
      ...theme.typography.body_extraLargeRegular
    }
  },
  optOutButtonContainer: {
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right'
    }
  }
}));

export default useStyles;
